module.exports = __webpack_public_path__ + "static/img/02_07_delay.449f608.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bias-fx2/sound-page/02_07_delay.png
// module id = dcOX
// module chunks = 12